import { render, staticRenderFns } from "./invoiceFailed.vue?vue&type=template&id=039fa059&scoped=true&"
import script from "./invoiceFailed.vue?vue&type=script&lang=js&"
export * from "./invoiceFailed.vue?vue&type=script&lang=js&"
import style0 from "./invoiceFailed.vue?vue&type=style&index=0&id=039fa059&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039fa059",
  null
  
)

export default component.exports